// Thin wrapper kept for backwards compatibility with any old
// /auth-callback links that may already be circulating. The actual
// handshake logic lives in <LoginBridge /> (pages/login-success.tsx),
// which is the single source of truth for "extract ?token=..., persist
// it, send the user into the dashboard".
import { LoginBridge } from '../pages/login-success';

export const AuthCallback = LoginBridge;
export default AuthCallback;